// Fix animate-on-scroll content that never becomes visible - runs before theme.js
// Covers: (1) single blog posts (template-article) with very long bodies, where
// sections deep in the page never get flagged visible; (2) the blog listing page
// (template-blog), where post cards can suffer the same issue; (3) as a general
// safety net, any .animate-on-scroll element that is already within (or above)
// the initial viewport on load, since the scroll-triggered IntersectionObserver
// never fires for content the user hasn't scrolled to reveal.
(function() {
  function revealAlreadyVisible() {
    var elements = document.querySelectorAll('.animate-on-scroll:not(.is-visible)');
    if (!elements.length) return;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    elements.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < viewportHeight) {
        el.classList.add('is-visible');
        el.classList.remove('animate-on-scroll');
      }
    });
  }

  function fixLongArticles() {
    var body = document.body;
    if (!body) return;
    var isArticle = body.classList.contains('template-article');
    var isBlogListing = body.classList.contains('template-blog');
    if (!isArticle && !isBlogListing) return;

    var shouldRevealAll = isBlogListing;
    if (isArticle) {
      var details = document.querySelector('.article__section-details');
      if (details && details.innerHTML.length > 15000) {
        shouldRevealAll = true;
      }
    }

    if (shouldRevealAll) {
      document.querySelectorAll('.animate-on-scroll').forEach(function(el) {
        el.classList.add('is-visible');
        el.classList.remove('animate-on-scroll');
      });
    }
  }

  function runFixes() {
    revealAlreadyVisible();
    fixLongArticles();
  }

  // Try immediately
  runFixes();
  // Also try when DOM is ready
  document.addEventListener('DOMContentLoaded', runFixes);
  // Also try after a short delay in case theme.js adds the class dynamically
  setTimeout(runFixes, 100);
  setTimeout(runFixes, 500);
})();

// Dynamic "smart" cart upsell - replaces the static merchant-picked product list
// with Shopify's native product recommendation engine, seeded primarily from
// what the shopper has actually been BROWSING (assets/track-recently-viewed.js),
// falling back to the most recently added cart item when no browsing history
// is available. No app required.
//
// Strategy: try "complementary" recommendations first (Shopify's "goes great
// with this" pairing engine - the same one powering the "Pair It With" block on
// product pages). That engine needs order history to have learned pairings, so
// on a low-order store it can return zero results. If it does, fall back to
// "related" (tag/type similarity), which works from day one. As the store
// accumulates orders, complementary recommendations will start returning
// results automatically - no code changes needed.
//
// Why a MutationObserver: the ajax cart content (snippets/cart-form.liquid) is
// re-injected via element.innerHTML on every add/remove/update. Script tags and
// event bindings inside innerHTML-injected markup never auto-run, so this file
// (loaded normally via <script src>) watches for that injection instead.
(function() {
  var lastFetchKey = null;

  // Browsing-history seed: reads the {id, handle, viewedAt} list written by
  // assets/track-recently-viewed.js on every product page visit, and returns
  // the most recently viewed product id that ISN'T already in the cart (as a
  // string, matching cartProductIds' string entries). Recommending products
  // related to something already sitting in the cart is redundant - the
  // shopper already decided on that one - so a not-yet-added product the
  // shopper was just looking at is a strictly more useful seed. Returns null
  // (falls back to the existing cart-item seed) whenever there's no history,
  // storage is unavailable, or everything browsed is already in the cart.
  function getRecentlyViewedSeedId(cartProductIds) {
    var raw;
    try {
      raw = window.localStorage.getItem('bf_recently_viewed');
    } catch (e) {
      return null;
    }
    if (!raw) return null;

    var history;
    try {
      history = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!Array.isArray(history)) return null;

    for (var i = 0; i < history.length; i++) {
      var entry = history[i];
      if (!entry || entry.id == null) continue;
      var idStr = String(entry.id);
      if (cartProductIds.indexOf(idStr) === -1) {
        return idStr;
      }
    }
    return null;
  }

  function extractInner(html, cartProductIds) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;

    // Strip out any recommended products already in the cart - the
    // recommendations endpoint has no knowledge of cart contents.
    if (cartProductIds.length) {
      wrapper.querySelectorAll('[data-cart-upsell-product-id]').forEach(function(el) {
        if (cartProductIds.indexOf(el.getAttribute('data-cart-upsell-product-id')) !== -1) {
          el.remove();
        }
      });
    }

    var inner = wrapper.querySelector('.js-dynamic-upsell-inner');
    if (!inner) return null;

    // If every item got filtered out as a cart duplicate, treat as empty too.
    var hasItems = inner.querySelector('[data-cart-upsell-product-id]');
    return hasItems ? inner : null;
  }

  function buildUrl(baseUrl, sectionId, productId, intent, limit) {
    return baseUrl + '?section_id=' + sectionId + '&product_id=' + productId + '&intent=' + intent + '&limit=' + limit;
  }

  // Guaranteed floor for when Shopify's native recommendation engine
  // returns nothing at all (both the "complementary" and "related" intents
  // came back empty - see loadDynamicCartUpsell below). This reads the
  // merchant-curated <template class="js-cart-upsell-static-fallback">
  // block rendered server-side in snippets/cart-form.liquid from the
  // existing settings.product_upsell list, clones it, strips out any items
  // already in the cart (same rule extractInner() applies to dynamic
  // results), and returns it - or null if nothing usable is left, in which
  // case the caller falls through to the previous (empty) behavior.
  function getStaticFallback(cartProductIds) {
    var template = document.querySelector('.js-cart-upsell-static-fallback');
    if (!template || !template.content) return null;

    var clone = template.content.querySelector('.js-dynamic-upsell-inner');
    if (!clone) return null;
    clone = clone.cloneNode(true);

    if (cartProductIds.length) {
      clone.querySelectorAll('[data-cart-upsell-product-id]').forEach(function(el) {
        if (cartProductIds.indexOf(el.getAttribute('data-cart-upsell-product-id')) !== -1) {
          el.remove();
        }
      });
    }

    return clone.querySelector('[data-cart-upsell-product-id]') ? clone : null;
  }

  function renderResult(container, inner) {
    if (!inner) {
      var cartProductIds = (container.dataset.cartProductIds || '').split(',').filter(Boolean);
      inner = getStaticFallback(cartProductIds);
    }

    container.innerHTML = inner ? inner.outerHTML : '';
    container.dataset.loaded = 'true';

    // NOTE: deliberately NOT calling Shopify.theme.ajaxCart.init() here.
    // That function unconditionally re-fetches /cart/?view=ajax and replaces
    // the ENTIRE .js-ajax-cart-content innerHTML, but - unlike updateView() -
    // it never re-binds the quantity +/- and remove-item click listeners
    // afterward. Calling it from here was wiping those listeners every time
    // the upsell block loaded, which is why the cart drawer's quantity and
    // remove controls stopped responding. The upsell items only contain an
    // Add to Cart button, option pickers, and (via the carousel nav script
    // below) prev/next scroll buttons, all handled by document-level
    // delegated listeners set up below - nothing here needs re-initializing.
  }

  function loadDynamicCartUpsell(container) {
    if (!container) return;
    var baseUrl = container.dataset.baseUrl;
    var sectionId = container.dataset.sectionId;
    var cartItemProductId = container.dataset.productId;
    var primaryIntent = container.dataset.intent || 'complementary';
    var fallbackIntent = container.dataset.fallbackIntent || 'related';
    var limit = container.dataset.limit || '10';
    var cartProductIds = (container.dataset.cartProductIds || '').split(',').filter(Boolean);

    var recentlyViewedSeedId = getRecentlyViewedSeedId(cartProductIds);
    var productId = recentlyViewedSeedId || cartItemProductId;

    if (!baseUrl || !productId) {
      return;
    }

    var fetchKey = productId + '|' + cartProductIds.join(',');
    if (fetchKey === lastFetchKey && container.dataset.loaded === 'true') {
      return;
    }
    lastFetchKey = fetchKey;

    var primaryUrl = buildUrl(baseUrl, sectionId, productId, primaryIntent, limit);

    fetch(primaryUrl)
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var inner = extractInner(html, cartProductIds);
        if (inner) {
          renderResult(container, inner);
          return;
        }

        // Primary intent came back empty - fall back to the intent that
        // doesn't depend on order history.
        if (!fallbackIntent || fallbackIntent === primaryIntent) {
          // If the recently-viewed seed itself returned nothing (e.g. it's a
          // low-catalog-relationship product), retry once from the original
          // cart-item seed before giving up entirely - a shopper should
          // never see an empty "Complete the set" block just because their
          // last-viewed product happens to have no computed relationships.
          if (recentlyViewedSeedId && cartItemProductId && cartItemProductId !== recentlyViewedSeedId) {
            var cartSeedUrl = buildUrl(baseUrl, sectionId, cartItemProductId, primaryIntent, limit);
            fetch(cartSeedUrl)
              .then(function(response) { return response.text(); })
              .then(function(cartSeedHtml) {
                renderResult(container, extractInner(cartSeedHtml, cartProductIds));
              })
              .catch(function() { renderResult(container, null); });
            return;
          }
          renderResult(container, null);
          return;
        }

        var fallbackUrl = buildUrl(baseUrl, sectionId, productId, fallbackIntent, limit);
        fetch(fallbackUrl)
          .then(function(response) { return response.text(); })
          .then(function(fallbackHtml) {
            renderResult(container, extractInner(fallbackHtml, cartProductIds));
          })
          .catch(function(error) {
            console.warn('Cart upsell fallback recommendations failed to load.', error);
            renderResult(container, null);
          });
      })
      .catch(function(error) {
        console.warn('Cart upsell recommendations failed to load.', error);
      });
  }

  function checkForUpsellContainer(root) {
    var container = (root || document).querySelector('.js-cart-dynamic-upsell');
    if (container) {
      loadDynamicCartUpsell(container);
    }
  }

  function observeCartContainers() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length) {
          checkForUpsellContainer(mutation.target);
        }
      });
    });

    document.querySelectorAll('.js-ajax-cart-content').forEach(function(el) {
      observer.observe(el, { childList: true, subtree: false });
    });

    // Cover the case where the content is already present on load.
    checkForUpsellContainer(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartContainers);
  } else {
    observeCartContainers();
  }
})();

// Fix slow Quick View popups. theme.js's quickview module rebinds a fresh
// click listener (a direct one on each button, plus a document-level
// delegated one, plus a prefetch IntersectionObserver per button) every
// single time Shopify.theme.quickview.init() runs - and it runs constantly:
// on page load, on section:select, and after nearly every ajax content
// update (cart changes, filter changes, recommendations loading, etc).
// Buttons accumulate duplicate listeners over a session, so a single click
// can end up firing many parallel product-template fetches at once - each
// one re-fetching, re-rendering, and re-initializing the quickview content -
// which is what makes the popup feel slow to open (and get slower the
// longer someone shops).
//
// Rather than hand-editing theme.js (a large compiled/bundled file, risky to
// patch directly), wrap quickview.init() so repeat calls after the first are
// no-ops. The very first call (which theme.js fires itself, synchronously,
// immediately after defining the object) still runs normally and binds
// everything correctly - this just stops it from happening again and again.
(function() {
  function patchQuickviewInit() {
    if (!(window.Shopify && Shopify.theme && Shopify.theme.quickview && Shopify.theme.quickview.init)) {
      return false;
    }
    var qv = Shopify.theme.quickview;
    if (qv._initDeduped) return true;

    // By the time this object exists in the global scope, theme.js has
    // already run its own top-level init() call once. From here on, treat
    // every further call as a no-op - the document-level delegated click
    // listener already covers all current AND future quickview buttons
    // (it matches via closest() at click time, not at bind time), so
    // nothing needs to be re-bound.
    qv.init = function() {};
    qv._initDeduped = true;
    return true;
  }

  if (!patchQuickviewInit()) {
    var attempts = 0;
    var poll = setInterval(function() {
      attempts++;
      if (patchQuickviewInit() || attempts > 60) clearInterval(poll);
    }, 50);
  }
})();

// The dedup patch above stops future init() calls from piling on MORE
// duplicate listeners, but theme.js's very first init() call (which runs
// inside theme.js itself, before this file even loads, so it can't be
// intercepted) already binds a quickview click TWICE per button: once as a
// direct listener on the button, and again via its own document-level
// delegated listener. That baseline double-fire is why even a single early
// click can feel slow. Catch the click in the capture phase (which always
// runs before other listeners, regardless of how many exist or when they
// were bound), handle it exactly once ourselves, and stop it from reaching
// any of theme.js's own handlers.
(function() {
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest && event.target.closest('.js-quickview-trigger');
    if (!trigger) return;
    if (!(window.Shopify && Shopify.theme && Shopify.theme.quickview && Shopify.theme.quickview.getTemplate)) {
      return; // quickview module not ready yet - let the normal click through
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var productUrl = trigger.dataset.productUrl;
    if (!productUrl) return;
    var cleanUrl = Shopify.theme.quickview.cleanUrl(productUrl, 'variant');
    Shopify.theme.quickview.getTemplate(cleanUrl);
  }, true);
})();

// Handle "Add to Cart" clicks for products inside the cart's dynamic
// "Complete the set" upsell (every upsell item now has one - see
// snippets/cart-upsell-item.liquid). Those buttons use the same
// .js-ajax-submit class theme.js normally binds inside
// Shopify.theme.ajaxCart.init() - but we deliberately never call that
// function again after page load (see the renderResult() note above: it
// silently wipes the cart drawer's quantity and remove listeners). So
// instead, replicate exactly what that binding does - call
// Shopify.theme.ajaxCart.addToCart() directly - via one delegated listener
// that covers every current and future upsell Add to Cart button. By the
// time this fires, the hidden .formVariantId input already holds whichever
// variant the option-resolver IIFE below last matched (or the product's
// default variant, if the shopper never touched the option selects).
//
// Each upsell card's variant-picker wrapper (.js-upsell-variant-form) is a
// <div>, not a real <form> - see the comment in cart-upsell-item.liquid for
// why (nested <form> elements are invalid HTML and get silently dropped by
// the browser when this markup is injected inside the ajax cart's own outer
// <form>; that was breaking the Add to Cart button and the variant/image
// swap for whichever card happened to land in the first carousel slot).
// Shopify.theme.ajaxCart.addToCart() only ever reads its first argument via
// `new FormData(addToCartForm)` - it never queries the DOM through it - so
// building a real, detached <form> element here via document.createElement
// (which is not subject to the parser's nested-form restriction) and
// copying the wrapper's named fields into it satisfies that requirement
// without needing an actual <form> anywhere in the rendered markup. All UI
// feedback (success/error notes, disabling the button) still targets the
// real wrapper via formContext, exactly as before.
(function() {
  function buildDetachedForm(wrapper) {
    var form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'post';
    var fields = wrapper.querySelectorAll('input[name], select[name]');
    fields.forEach(function(field) {
      form.appendChild(field.cloneNode(true));
    });
    return form;
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('.js-cart-dynamic-upsell .js-ajax-submit');
    if (!button) return;
    if (button.disabled) return;
    if (!(window.Shopify && Shopify.theme && Shopify.theme.ajaxCart && Shopify.theme.ajaxCart.addToCart)) {
      return;
    }

    event.preventDefault();

    var configEl = document.getElementById('cart-config');
    if (!configEl) return;
    var config = JSON.parse(configEl.innerHTML || '{}');
    var wrapper = button.closest('.js-upsell-variant-form');
    if (!wrapper) return;
    var detachedForm = buildDetachedForm(wrapper);

    Shopify.theme.ajaxCart.addToCart(detachedForm, button.parentNode, config, false);
  });
})();

// Resolve the Size/Color/etc. option(s) picked in a cart upsell item's
// inline <select> dropdowns (snippets/cart-upsell-item.liquid) to a matching
// variant, and keep the hidden variant id input, Add to Cart button state,
// and product image in sync as selections change. Delegated 'change'
// listener for the same innerHTML-re-injection reason as everything else in
// this file - the selects are re-created every time recommendations load or
// the cart updates, so anything bound directly to them would be silently
// dropped. form here is the .js-upsell-variant-form <div> wrapper (see
// cart-upsell-item.liquid) - querySelector/closest work on it exactly like
// they would on a real <form>.
(function() {
  function getVariants(form) {
    if (form._upsellVariants) return form._upsellVariants;
    var script = form.querySelector('.js-upsell-variants-json');
    if (!script) return null;
    try {
      form._upsellVariants = JSON.parse(script.textContent);
    } catch (e) {
      form._upsellVariants = [];
    }
    return form._upsellVariants;
  }

  function findMatchingVariant(variants, selectedValues) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var matches = true;
      for (var j = 0; j < selectedValues.length; j++) {
        var key = 'option' + (j + 1);
        if (variant[key] !== selectedValues[j]) {
          matches = false;
          break;
        }
      }
      if (matches) return variant;
    }
    return null;
  }

  // Variant image URLs come back from the JSON as the original, full-size
  // file (e.g. "...tee.jpg?v=123") - append Shopify's CDN width param so the
  // swapped-in image is sized to match what basic-responsive-image.liquid
  // would have requested, instead of downloading a full-resolution original
  // into a ~140px card.
  function sizedImageUrl(src, width) {
    if (!src) return src;
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'width=' + width;
  }

  function updateImage(form, variant) {
    var image = variant && variant.featured_image;
    if (!image || !image.src) return;

    var card = form.closest('.cart-form__upsell-item');
    if (!card) return;
    var img = card.querySelector('.js-upsell-item-image img');
    if (!img) return;

    var newSrc = sizedImageUrl(image.src, 600);
    if (img.dataset.currentVariantImage === newSrc) return;

    img.dataset.currentVariantImage = newSrc;
    // Drop srcset/sizes so the browser can't fall back to a stale
    // multi-resolution candidate from the original variant's image set.
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = newSrc;
    if (image.alt) img.alt = image.alt;
  }

  function updateForm(form) {
    var variants = getVariants(form);
    if (!variants || !variants.length) return;

    var selects = Array.prototype.slice.call(form.querySelectorAll('.js-upsell-option-select'));
    selects.sort(function(a, b) {
      return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
    });
    var selectedValues = selects.map(function(select) { return select.value; });

    var match = findMatchingVariant(variants, selectedValues);
    var variantInput = form.querySelector('.js-upsell-variant-id');
    var addBtn = form.querySelector('.js-upsell-add-btn');
    if (!variantInput || !addBtn) return;

    if (match) {
      variantInput.value = match.id;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? addBtn.dataset.addLabel : addBtn.dataset.soldOutLabel;
      updateImage(form, match);
    } else {
      // No variant exists for this exact combination (can happen with
      // partial/mismatched option sets) - block adding rather than
      // submitting a stale variant id.
      addBtn.disabled = true;
      addBtn.textContent = addBtn.dataset.soldOutLabel;
    }
  }

  document.addEventListener('change', function(event) {
    var select = event.target.closest && event.target.closest('.js-upsell-option-select');
    if (!select) return;
    var form = select.closest('.js-upsell-variant-form');
    if (!form) return;
    updateForm(form);
  });
})();

// Cart upsell carousel prev/next controls. The ".scroll-wrapper" row always
// supported drag/swipe scrolling, but had no visible affordance for mouse
// users to advance it - nothing communicated more products were off-screen.
// Delegated listeners (rather than binding directly to each button) because
// the upsell markup is re-injected via innerHTML whenever recommendations
// load or the cart updates (see the dynamic-upsell loader above), which
// would silently drop any directly-bound listeners.
(function() {
  function getTrack(scrollBtn) {
    var wrapper = scrollBtn.closest('.upsell--carousel_wrapper');
    return wrapper ? wrapper.querySelector('.js-upsell-scroll-wrapper') : null;
  }

  function updateNavState(track) {
    var wrapper = track.closest('.upsell--carousel_wrapper');
    if (!wrapper) return;
    var prevBtn = wrapper.querySelector('.js-upsell-scroll-prev');
    var nextBtn = wrapper.querySelector('.js-upsell-scroll-next');
    var maxScroll = track.scrollWidth - track.clientWidth;

    // Nothing to scroll at all (e.g. only 1-2 recommendations returned) -
    // hide both controls rather than show a pair of buttons that do nothing.
    if (maxScroll <= 4) {
      if (prevBtn) prevBtn.classList.add('is-hidden');
      if (nextBtn) nextBtn.classList.add('is-hidden');
      return;
    }

    if (prevBtn) prevBtn.classList.toggle('is-hidden', track.scrollLeft <= 4);
    if (nextBtn) nextBtn.classList.toggle('is-hidden', track.scrollLeft >= maxScroll - 4);
  }

  // Advance by TWO cards per click (not one). Card pitch is measured from the
  // real distance between the first two cards, so it includes the gap.
  function scrollByCard(track, direction) {
    var cards = track.querySelectorAll('.cart-form__upsell-item--outer');
    var pitch;
    if (cards.length > 1) {
      pitch = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    } else if (cards.length === 1) {
      pitch = cards[0].getBoundingClientRect().width + 10;
    } else {
      pitch = track.clientWidth * 0.4;
    }
    track.scrollBy({ left: direction * pitch * 2, behavior: 'smooth' });
  }

  document.addEventListener('click', function(event) {
    var prevBtn = event.target.closest && event.target.closest('.js-upsell-scroll-prev');
    var nextBtn = event.target.closest && event.target.closest('.js-upsell-scroll-next');
    var btn = prevBtn || nextBtn;
    if (!btn) return;
    var track = getTrack(btn);
    if (!track) return;
    event.preventDefault();
    scrollByCard(track, prevBtn ? -1 : 1);
  });

  // scroll events don't bubble, so listen during the capture phase instead -
  // that still fires for a scroll anywhere in the document, including on the
  // track element itself, without needing a listener bound per-instance.
  document.addEventListener('scroll', function(event) {
    var track = event.target;
    if (!(track && track.classList && track.classList.contains('js-upsell-scroll-wrapper'))) return;
    updateNavState(track);
  }, true);

  function initAllTracks(root) {
    (root || document).querySelectorAll('.js-upsell-scroll-wrapper').forEach(updateNavState);
  }

  // Re-check whenever the cart content is re-rendered - covers both the
  // outer .js-ajax-cart-content swap (cart opened/updated) and the inner
  // .js-cart-dynamic-upsell swap (recommendations finish loading).
  document.querySelectorAll('.js-ajax-cart-content').forEach(function(el) {
    new MutationObserver(function() { initAllTracks(el); }).observe(el, { childList: true, subtree: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAllTracks(document); });
  } else {
    initAllTracks(document);
  }

  window.addEventListener('resize', function() { initAllTracks(document); });
})();

// Fix a stray "blinking bar" visual artifact: after clicking a cart quantity
// input, if the page reflows for any reason while that input still holds
// focus - most commonly the header's auto-rotating announcement banner
// changing text and shifting content below it by a few pixels - Chromium can
// leave a stale caret rendered at the input's PREVIOUS on-screen position
// instead of its new one. caret-color:transparent (set in
// section-main-cart.css) prevents the input's own caret from ever being
// visible, but this is a separate compositor-level glitch that isn't fully
// covered by that. The real fix is to not leave the input sitting focused
// indefinitely: blur it automatically a moment after the user stops actively
// typing, and immediately on scroll (scrolling always implies the user has
// moved on from typing a quantity). The +/- buttons remain the primary way
// to change quantity and are completely unaffected by this - they never
// leave the number input focused.
(function() {
  var IDLE_BLUR_MS = 1200;
  var idleTimer = null;

  function isQtyInput(el) {
    return el && el.classList && el.classList.contains('ajax-cart__qty-input') && !el.classList.contains('ajax-cart__qty-input--no-js');
  }

  function clearIdleTimer() {
    if (idleTimer) {
      clearTimeout(idleTimer);
      idleTimer = null;
    }
  }

  function scheduleIdleBlur(el) {
    clearIdleTimer();
    idleTimer = setTimeout(function() {
      if (document.activeElement === el) {
        el.blur();
      }
    }, IDLE_BLUR_MS);
  }

  document.addEventListener('focusin', function(event) {
    if (isQtyInput(event.target)) {
      scheduleIdleBlur(event.target);
    }
  });

  document.addEventListener('keydown', function(event) {
    if (isQtyInput(event.target)) {
      scheduleIdleBlur(event.target);
    }
  });

  document.addEventListener('focusout', function(event) {
    if (isQtyInput(event.target)) {
      clearIdleTimer();
    }
  });

  window.addEventListener('scroll', function() {
    var active = document.activeElement;
    if (isQtyInput(active)) {
      active.blur();
    }
  }, { passive: true, capture: true });
})();

// CLS fix: keep the sticky-header spacer's compensation height in sync with
// reality. theme.js's <theme-header> component measures
// this.elements.headerWrapper.offsetHeight exactly ONCE, at page load, and
// writes it to the --header-height custom property that
// .navigation--sticky.navigation + .header-spacer uses for its margin-top
// (see the inline <style> block in sections/header.liquid). It's only ever
// refreshed again on a 980px breakpoint crossing - never on scroll, and
// never when the header's actual rendered height changes for any other
// reason (a webfont finishing its swap, the announcement carousel rotating
// to a message that wraps differently, a locale/currency selector changing
// width, zoom level, etc). makeNavigationSticky() - the function that adds
// the 'navigation--sticky' class on every scroll event - never recalculates
// this value at all. So whenever the header's real height at the moment it
// goes sticky differs from that stale load-time snapshot, the page content
// jumps by the difference: a genuine, scroll-triggered layout shift that
// counts fully against CLS (only shifts within 500ms of a discrete input
// like a click/tap are excluded - continuous scroll doesn't qualify).
//
// Fix: keep --header-height continuously accurate via a ResizeObserver on
// the header wrapper (catches every cause above at the source, the instant
// it happens), plus a belt-and-suspenders re-measure right as the sticky
// class actually flips, in case a resize and the scroll-driven toggle land
// in the same frame. Deliberately doesn't touch theme.js itself (large,
// bundled, risky to hand-edit) - this only adds a second, independent sync
// path alongside it.
(function() {
  var headerWrapper = document.querySelector('.js-header-wrapper');
  var nav = document.querySelector('.js-navigation');
  if (!headerWrapper) return;

  function syncHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', headerWrapper.offsetHeight + 'px');
  }

  syncHeaderHeight();

  if (window.ResizeObserver) {
    new ResizeObserver(syncHeaderHeight).observe(headerWrapper);
  } else {
    window.addEventListener('resize', syncHeaderHeight);
  }

  if (nav) {
    var stickyClass = nav.dataset.stickyClass || 'navigation--sticky';
    var wasSticky = nav.classList.contains(stickyClass);
    window.addEventListener('scroll', function() {
      var isSticky = nav.classList.contains(stickyClass);
      if (isSticky !== wasSticky) {
        syncHeaderHeight();
        wasSticky = isSticky;
      }
    }, { passive: true });
  }
})();
